/* ARCHER footer — mobile accordion for the link sections (.archer-ft-colgroup).
   Desktop/tablet (>767px) keeps every link visible and the heads inert; on
   mobile each head becomes a +/× toggle. CSS lives in each page's trailing
   #archer-mobile-redesign block. */
(function () {
  var mq = window.matchMedia('(max-width: 767px)');
  var groups = document.querySelectorAll('.archer-ft-colgroup');
  if (!groups.length) return;

  groups.forEach(function (group) {
    var head = group.querySelector('.archer-ft-col-head');
    var links = group.querySelector('.archer-ft-col-links');
    if (!head || !links) return;

    function sync() {
      if (mq.matches) {
        head.setAttribute('role', 'button');
        head.setAttribute('tabindex', '0');
        head.setAttribute('aria-expanded', String(group.classList.contains('is-open')));
      } else {
        head.removeAttribute('role');
        head.removeAttribute('tabindex');
        head.removeAttribute('aria-expanded');
        group.classList.remove('is-open');
      }
    }

    function toggle() {
      if (!mq.matches) return;
      group.classList.toggle('is-open');
      head.setAttribute('aria-expanded', String(group.classList.contains('is-open')));
    }

    head.addEventListener('click', toggle);
    head.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });

    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else mq.addListener(sync);
  });
})();
